var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"mb-2"},[_c('v-system-bar',[_vm._v("LookupValue")]),_c('v-card-text',[_c('p',[_vm._v("Stellt einen LookupValue dar.")]),_c('v-row',[_c('v-col',[_c('LookupValue',{attrs:{"value":_vm.value}})],1),_c('v-col')],1),_c('code',[_vm._v("<LookupValue :value=\"value\"/>")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }